export default "__VITE_ASSET__f7eb0f7a__"